'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const useScrollAnimation = () => {
  const pathname = usePathname()
  useEffect(() => {
    const callback: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.setAttribute('data-in-view', 'true');

            // Once animated, we don't need to watch it anymore
            observer.unobserve(entry.target);
          }, (parseInt(entry.target.getAttribute('data-scroll-animation-delay') || "0")));
        }
      });
    };

    // Observer options
    const options: IntersectionObserverInit = {
      root: null, // relative to the viewport
      rootMargin: '0px',
      threshold: 0.1, // trigger when 10% of the element is visible
    };

    // Create the single, global observer
    const observer = new IntersectionObserver(callback, options);

    // Find all elements to animate and start observing them
    const elements = document.querySelectorAll("[data-scroll-animation]");
    elements.forEach(element => observer.observe(element));

    // Cleanup function to disconnect the observer when the component unmounts
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [pathname]); // The empty dependency array ensures this runs only once on mount
};
